import React, { useContext, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { LinkContainer } from 'react-router-bootstrap'
import { Container, Row, Col, Card, Button } from 'react-bootstrap'
import { getinventorySummary } from '../actions/inventoryActions'
import Message from '../components/Message'
import Loader from '../components/Loader'
import { ThemeContext } from '../components/ThemeContext.js'
import {
  EMPLOYEE_PERMISSIONS,
  hasEmployeePermission
} from '../constants/employeePermissions.js'

let inventorysunk = 0
let inventorygross = 0

const Dashboard = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { theme } = useContext(ThemeContext)

  const userLogin = useSelector((state) => state.userLogin)
  const { userInfo } = userLogin

  const ownerLogin = useSelector((state) => state.ownerLogin)
  const { ownerInfo } = ownerLogin

  const canViewReports = hasEmployeePermission(
    userInfo,
    ownerInfo,
    EMPLOYEE_PERMISSIONS.REPORTS_VIEW
  )

  // Get inventory summary
  const inventorySummary = useSelector((state) => state.inventorySummary)
  const {
    loading,
    error,
    inventoryCount,
    manufacturerCount,
    itemCount,
    inventorycost,
    inventoryvalue
  } = inventorySummary

  if (inventorycost !== undefined) {
    inventorysunk = inventorycost.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD'
    })
    inventorygross = inventoryvalue.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD'
    })
  }

  useEffect(() => {
    if (!userInfo && !ownerInfo) {
      localStorage.removeItem('qrcodeScan')
      localStorage.removeItem('userInfo')
      navigate('/login')
    } else if (!canViewReports) {
      navigate('/pos')
    } else {
      dispatch(getinventorySummary())
    }
  }, [navigate, userInfo, ownerInfo, canViewReports, dispatch])

  return (
    <Container style={{ color: theme.text }}>
      {inventoryCount === 0 && <Message variant='info'>None Found</Message>}
      {loading ?
        <Loader />
      : error ?
        <Message variant='danger'>{error}</Message>
      : <>
          <Row className='my-3'>
            <Col>
              <Card
                className='text-left my-1 py-1'
                style={{
                  backgroundColor: theme.card,
                  color: theme.text,
                  borderColor: theme.sidebarAccent
                }}
              >
                <Card.Title>Total Inventory</Card.Title>
                <Card.Body>
                  <Card.Text>
                    There are {inventoryCount} units in the inventory.
                  </Card.Text>
                </Card.Body>
                <Card.Footer
                  style={{
                    backgroundColor: theme.surfaceMuted,
                    color: theme.subtext,
                    borderColor: theme.sidebarAccent
                  }}
                >
                  <LinkContainer to='/inventory'>
                    <Button size='sm' variant='outline-primary'>
                      Inventory
                    </Button>
                  </LinkContainer>
                </Card.Footer>
              </Card>
            </Col>
            <Col>
              <Card
                className='text-left my-1 py-1'
                style={{
                  backgroundColor: theme.card,
                  color: theme.text,
                  borderColor: theme.sidebarAccent
                }}
              >
                <Card.Title>Total Items</Card.Title>
                <Card.Body>
                  <Card.Text>There are {itemCount} items.</Card.Text>
                </Card.Body>
                <Card.Footer
                  style={{
                    backgroundColor: theme.surfaceMuted,
                    color: theme.subtext,
                    borderColor: theme.sidebarAccent
                  }}
                >
                  {' '}
                  <LinkContainer to='/items'>
                    <Button size='sm' variant='outline-primary'>
                      Items
                    </Button>
                  </LinkContainer>
                </Card.Footer>
              </Card>
            </Col>
          </Row>
          <Row className='my-3'>
            <Col>
              <Card
                className='text-left my-1 py-1'
                style={{
                  backgroundColor: theme.card,
                  color: theme.text,
                  borderColor: theme.sidebarAccent
                }}
              >
                <Card.Title>Total Suppliers</Card.Title>
                <Card.Body>
                  <Card.Text>
                    There are {manufacturerCount} suppliers.
                  </Card.Text>
                </Card.Body>
                <Card.Footer
                  style={{
                    backgroundColor: theme.surfaceMuted,
                    color: theme.subtext,
                    borderColor: theme.sidebarAccent
                  }}
                >
                  {' '}
                  <LinkContainer to='/name'>
                    <Button size='sm' variant='outline-primary'>
                      Manufacturers
                    </Button>
                  </LinkContainer>
                </Card.Footer>
              </Card>
            </Col>

            <Col>
              <Card
                className='text-left my-1 py-1'
                style={{
                  backgroundColor: theme.card,
                  color: theme.text,
                  borderColor: theme.sidebarAccent
                }}
              >
                <Card.Title>Total Value</Card.Title>
                <Card.Body>
                  <Card.Text>
                    The inventory cost is {inventorysunk}
                    <br />
                    The inventory value is {inventorygross}
                  </Card.Text>
                </Card.Body>
                <Card.Footer
                  style={{
                    backgroundColor: theme.surfaceMuted,
                    color: theme.subtext,
                    borderColor: theme.sidebarAccent
                  }}
                >
                  <strong>Value is the number of items at retail price</strong>
                </Card.Footer>
              </Card>
            </Col>
          </Row>
        </>
      }
    </Container>
  )
}

export default Dashboard
